<div class="white-background" *ngIf="showStripeDashBoard">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div class="p-4">
            <img class="" ngSrc="/assets/img/logo.png" alt="LOGO" width="340" height="68" />
        </div>

        <div class="tagline">
            <h5 class="text-weight-bold " style="color: #3BA378">
                World’s Most Reliable Certification Manager for
                <i>Competitive</i> Professionals
            </h5>
        </div>
    </div>
    <div class="text-center">
        <img class="mt-2 mb-5" ngSrc="/assets/img/Welcome-to-Your-New-Wallet!.png" alt="" width="374" height="89" />
    </div>
    <div class="container white-background">

        <div *ngIf="hasRoleAdmin" class="text-end">
            <button mat-raised-button color="primary" (click)="toBackoffice()">Skip to admin backoffice</button>
        </div>

        <div class="payment_container my-3">
            <stripe-pricing-table
                    [attr.pricing-table-id]="stripe_table_id"
                    [attr.publishable-key]="stripe_key"
                    [attr.customer-session-client-secret]="clientID">
            </stripe-pricing-table>
        </div>
        <div class="px-5">
            <p><b>Please Note:</b> You are about to temporarily transition from CertWallet to Stripe to complete your membership purchase. Upon successful payment, you will transition back to your new dashboard.
                We appreciate your business and are excited to support your career journey with us.</p>

            <p>To ensure a seamless subscription process, please use the same email address as your login email.</p>

        </div>
        <div class="col-md-12 d-flex justify-content-center mb-5" >
            <a (click)="logout()" mat-raised-button color="primary" style="width: 200px; margin-top: 10px; margin-bottom: 10px;">
                <span class="fas fa-sign-out-alt" style="margin-right: 10px;" ></span>Cancel
            </a>
        </div>

    </div>
</div>





